import { useState } from 'react';
import { api } from '../lib/api';

/**
 * "Pedir renovación" (RFC-0027) para quien no puede entrar porque el plan
 * de su organización venció o la cuenta está suspendida. Avisa al dueño
 * con el contexto; la respuesta del API es siempre la misma, exista o no
 * la cuenta, así que aquí tampoco se promete nada distinto.
 */
export function RenewalRequest({ email, reason }: { email: string; reason: string }) {
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const clean = email.trim();
  if (!clean) return null;

  async function send() {
    if (state === 'sending') return;
    setState('sending');
    try {
      await api.accountRenewalRequest(clean);
      setState('sent');
    } catch {
      setState('error');
    }
  }

  if (state === 'sent') {
    return (
      <div className="auth-ok">
        Listo: le avisamos a TerraKairos. Te contactarán en <strong>{clean}</strong>.
      </div>
    );
  }
  return (
    <>
      <button type="button" className="auth-submit auth-submit-secondary" onClick={send} disabled={state === 'sending'}>
        {state === 'sending' ? 'Enviando…' : reason === 'org_suspended' ? 'Pedir que reactiven la cuenta' : 'Pedir renovación'}
      </button>
      {state === 'error' && <div className="auth-error">No pudimos enviar el aviso. Intenta de nuevo en un momento.</div>}
    </>
  );
}
